import { render } from "./HiAlert.vue?vue&type=template&id=ec6e1904"
import script from "./HiAlert.vue?vue&type=script&lang=js"
export * from "./HiAlert.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__